<template>
    
    <div class="color-danger-900 text-center" v-if="user.guest">
        Для подачі заявок необхідно авторизуватись на сайті.
    </div>
    
    <div class="container-fluid" v-else>
        <div class="row">
            <div class="col-sm-4">
                <div class="custom-control custom-checkbox pl-0 pb-2">
                    <BFormCheckbox
                        :disabled="is_guest"
                        id="deliverypayment_ok"
                        v-model="request.deliverypayment_ok"
                        name="checkbox-1">
                        <span class="text fw-700" style="margin-left: 5px;margin-top: -2px">З умовами оплати і постачання згоден</span>
                    </BFormCheckbox>
                </div>
                
                <BButton v-if="!request.deliverypayment_ok" variant="outline-primary" @click="showModal">
                    Вказати свої умови
                </BButton>
                
            </div>
            <div class="col-sm-8 pay_custom">
                <div v-if="!request.deliverypayment_ok">
                    <span v-if="!is_set_own" class="fw-600" >Погодьтесь із запропонованими умовами, або вкажіть свої.</span>
                    
                    <div class="pay_custom" v-else>
                        <div class="row bottom5">
                            <div class="col-sm-12">
                                <b>Оплата:</b> {{curPayment}}
                            </div>
                        </div>
                        
                        <div class="row bottom5">
                            <div class="col-sm-12">
                                <b>Постачання:</b> {{curDelivery?.title}}
                            </div>
                        </div>
                        
                        <div class="row bottom5">
                            <div class="col-sm-12">
                                <b>Дата постачання:</b> {{request?.date_delivery}}
                            </div>
                        </div>
                    </div>
                </div>
                
                <div v-else>
                    <div class="pay_standart" >
                        <div class="row bottom5">
                            <div class="col-sm-12">
                                <b>Оплата:</b> {{tender?.payment.title}}
                            </div>
                        </div>
                        
                        <div class="row bottom5">
                            <div class="col-sm-12">
                                <b>Постачання:</b> {{tender?.delivery.title}}</div>
                        </div>
                        
                        <div class="row bottom5">
                            <div class="col-sm-12">
                                <b>Дата постачання:</b> {{tender?.date_delivery}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <request_modal_custom_modal @override_finish="push_request_edit" :request="request"></request_modal_custom_modal>
    </div>
    
</template>

<script>
import {mapGetters} from "vuex";
import {
    BButton,
    BFormCheckbox,
    BInput,
    BModal
} from 'bootstrap-vue-next';
import request_modal_custom_modal from "./request_modal_custom_modal.vue";

export default {
    name: "tender_custom_payment",
    props : {
        tender : {
            type : Object,
            required : true
        }
    },
    
    components : {
        request_modal_custom_modal,
        BButton,
        BInput,
        BFormCheckbox,
        BModal
    },
    
    data() {
        return {
            deliveries : [],
        }
    },

    created() {
        this.loadDeliveries();
    },
    
    methods : {
        
     
        
        async loadDeliveries() {
            this.deliveries = [];
            await api.get('/tenders/list/deliveries').then(({data}) => {
                if (data.status === "operation_success") {
                    this.deliveries = data.data;
                }
            })
        },
        
        push_request_edit(params) {
            const check = ['delivery_ok', 'date_delivery_ok', 'payment_ok'];
            const p = (params && typeof params === 'object') ? params : {};
            const allTrue = check.every(k => p[k] === true);
            
            if (!this.tender.request) this.tender.request = {};
            
            if (allTrue) {
                this.tender.request.deliverypayment_ok = true;
                return;
            }
            
            this.tender.request.deliverypayment_ok = false;
            
            // 1) слить все поля как есть
            this.tender.request = {
                ...this.tender.request,
                ...p,
                // 2) payment Object
                ...(p.payment ? { payment: { ...p.payment } } : {})
            };
        },
        
        showModal() {
            EventBus.$emit('show_payment_edit');
        },
    },
    
    computed : {
        
        curPayment() {
            
            const pay = this.request?.override?.payment;
            if (!pay || typeof pay !== 'object') return '';
            
            const toInt = v => {
                const n = parseInt(String(v ?? '').trim(), 10);
                return Number.isFinite(n) ? n : 0;
            };
            const toStr = v => String(v ?? '').trim();
            
            const prepay       = toInt(pay.prepay);                    // 0..100
            const prepayDesc   = toStr(pay.prepay_description);        // текст после предоплаты
            const postday      = toInt(pay.postday);                   // дней отсрочки
            const postperiod   = toStr(pay.postperiod || '0');         // "0"|"1"|"2"
            const postpayDesc  = toStr(pay.postpay_description);       // текст после постоплаты
            const postpay      = Math.max(0, 100 - prepay);
            
            let postperiodText = 'Оплата в кінці строку';
            if (postperiod === '1') postperiodText = 'Оплата щомісяця рівними частинами';
            else if (postperiod === '2') postperiodText = 'Оплата щотижня рівними частинами';
            
            // Сборка строки
            if (prepay >= 100) {
                return ['Предоплата 100%', prepayDesc]
                    .filter(Boolean)
                    .join(' ')
                    .replace(/\s+/g, ' ')
                    .trim();
            }
            
            return [
                `Предоплата ${prepay}%`,
                prepayDesc,
                `Відстрочка ${postpay}%`,
                `Після поставки на ${postday} днів.`,
                postperiodText,
                postpayDesc
            ]
                .filter(Boolean)
                .join(' ')
                .replace(/\s+/g, ' ')
                .trim();
        },
        
        curDelivery() {
            const id = Number(this.request?.delivery_id);
            if (!id) return null;
            
            return this.deliveries.find(d => Number(d.id) === id) || null;
        },
        
        canPut() {
            return true;
        },
        
        request () {
            return this.tender.request;
        },
        
        is_set_own () {
            const p = this.request;
            
            let check = ['delivery_ok', 'date_delivery_ok', 'payment_ok',];
            return  !check.every(k => p[k] === true);
        },
        
        ...mapGetters({
            'user': "user/getUser",
        }),
        
        is_guest  () {
            return this.user.guest == 1;
        }
    }
}
</script>



<style scoped>

</style>